import css from 'styled-jsx/css';
import { LeadFormFields } from 'types/LeadForm';
import { LeadSubmission } from 'lib/hooks/useSubmitted';
import Form from './Form';
import styles from './styles';
import Title from './Title';
import FormManager, { SubmissionState } from './FormManager';

interface LeadFormProps {
  dealerPhone?: string | null;
  showZipCode?: boolean;
  showAddress?: boolean;
  onSubmit: (fields: LeadFormFields) => Promise<void>;
  leadSubmission: LeadSubmission;
  leadFormClass?: string;
}

const contactButtonCss = css.resolve`
  width: 100%;
`;

const marginCss = css.resolve`
  margin: 0px 16px;
`;

function LeadForm({
  showZipCode,
  showAddress,
  dealerPhone,
  onSubmit,
  leadSubmission,
}: LeadFormProps): JSX.Element {
  return (
    <div className="lead-form" data-testid="lead-form">
      <FormManager showZipCode={showZipCode} showAddress={showAddress} onSubmit={onSubmit}>
        {({ submissionState }: { submissionState: SubmissionState }): JSX.Element => {
          const isSubmitted =
            leadSubmission.isSubmitted || submissionState === SubmissionState.submitted;

          return (
            <>
              <Title isSubmitted={isSubmitted} />
              <Form
                dealerPhone={dealerPhone}
                showZipCode={showZipCode}
                showAddress={showAddress}
                submissionState={
                  leadSubmission.isSubmitted ? SubmissionState.submitted : submissionState
                }
                isSubmitted={isSubmitted}
                leadSubmission={leadSubmission}
              />
            </>
          );
        }}
      </FormManager>
      <style jsx>{styles}</style>
      {marginCss.styles}
      {contactButtonCss.styles}
    </div>
  );
}

export default LeadForm;
